import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ExploreSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ExploreSVG;
